import { TipAdjustmentSaleFields } from "../interfaces/sales";

/**
 * Card processors that expose no refund API to the backend, so a full cancellation refunds the
 * customer by SPEI and the operator has to type the phone that receives the WhatsApp. Verifone
 * terminals (Afirme acquirer) authorize on the device itself, so they are refunded this way too.
 * Sale and bill detail both read this list; keep it here so a new processor is added once.
 */
export const SPEI_MERCHANTS: string[] = ["bankaool", "clover", "verifone"];

/**
 * A tip-adjustment sale is the one created to reassign a seller's tip to their primary
 * concession. The API exposes this via the sale's `type` field ("tip_adjustment"), so the
 * classification is authoritative instead of inferred from subtotal/products.
 * @param sale Sale with its `type` field
 * @returns true when the sale is a tip-adjustment sale
 */
export const isTipAdjustmentSale = (sale: TipAdjustmentSaleFields): boolean => {
  return sale.type === "tip_adjustment";
};
